import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function CopilotIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon width="30px" height="30px" fill="none" viewBox="0 0 30 30" {...props}>
      <Box
        as="path"
        fill={`url(#copilot-icon-a${id})`}
        fillRule="evenodd"
        d="M5 15c0 5.523 4.477 10 10 10v2.5C8.096 27.5 2.5 21.904 2.5 15S8.096 2.5 15 2.5 27.5 8.096 27.5 15H25c0-5.523-4.477-10-10-10S5 9.477 5 15Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        fill={`url(#copilot-icon-b${id})`}
        fillRule="evenodd"
        d="M25 15.002V15h2.5v.003a1.25 1.25 0 0 1-2.5 0Zm.876 3.147c.638.264.94.996.676 1.633l-.002.006a1.25 1.25 0 0 1-2.31-.958l.003-.005a1.25 1.25 0 0 1 1.633-.676Zm-2.035 3.92a1.25 1.25 0 0 1 0 1.768l-.004.004a1.25 1.25 0 0 1-1.768-1.768l.004-.004a1.25 1.25 0 0 1 1.768 0Zm-3.378 2.847a1.25 1.25 0 0 1-.675 1.634l-.006.002a1.25 1.25 0 0 1-.957-2.31l.005-.001a1.25 1.25 0 0 1 1.633.675ZM15 25h.002a1.25 1.25 0 0 1 .001 2.5H15V25Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        fill={`url(#copilot-icon-c${id})`}
        d="M8.75 15A6.25 6.25 0 0 0 15 21.25V8.75A6.25 6.25 0 0 0 8.75 15Z"
      />
      <defs>
        <linearGradient
          id={`copilot-icon-a${id}`}
          x1="9.375"
          x2="25"
          y1="27.5"
          y2="6.25"
          gradientUnits="userSpaceOnUse"
        >
          <Box as="stop" stopColor="#BC85FA" />
          <Box as="stop" offset="1" stopColor="#8CDBE9" />
        </linearGradient>
        <linearGradient
          id={`copilot-icon-b${id}`}
          x1="9.375"
          x2="25"
          y1="27.5"
          y2="6.25"
          gradientUnits="userSpaceOnUse"
        >
          <Box as="stop" stopColor="#BC85FA" />
          <Box as="stop" offset="1" stopColor="#8CDBE9" />
        </linearGradient>
        <linearGradient
          id={`copilot-icon-c${id}`}
          x1="9.375"
          x2="25"
          y1="27.5"
          y2="6.25"
          gradientUnits="userSpaceOnUse"
        >
          <Box as="stop" stopColor="#BC85FA" />
          <Box as="stop" offset="1" stopColor="#8CDBE9" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
